module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages"
  }, [_c('z-table', {
    attrs: {
      "offset": _vm.params.offset,
      "count": _vm.params.count,
      "total-count": _vm.list.item_total
    },
    on: {
      "handleOffset": _vm.handleOffset
    }
  }, [_vm._l((_vm.columns), function(item) {
    return _c('th', {
      attrs: {
        "slot": "columns"
      },
      slot: "columns"
    }, [_vm._v(_vm._s(item))])
  }), _vm._v(" "), _vm._l((_vm.list.list || []), function(item, index) {
    return _c('tr', {
      attrs: {
        "slot": "datasource"
      },
      slot: "datasource"
    }, [_c('td', [_vm._v(_vm._s(item.type == 1 ? '客服消息群发' : '群发接口群发'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("filterMaterialType")(item.mass_type)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.type == 1 ? item.success_num : '全部'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fail_num))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("momentFmt")(item.c_time)))]), _vm._v(" "), _c('td', {
      class: [item.status == 0 ? 'ing' : 'success']
    }, [_vm._v(_vm._s(item.status == 0 ? '发送中...' : '发送成功'))])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-b10ad4ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/wechat/WxMassList.vue
// module id = 883
// module chunks = 0